// This file was auto generated by resource-sync tools.

import ar_b_fe_vss from './ar/b_fe_vss.json';
import en_b_fe_vss from './en/b_fe_vss.json';
import zh_b_fe_vss from './zh/b_fe_vss.json';


const resources = {
    'namespaces': 
    [{"localeInfos":[{"locale":"ar","version":156},{"locale":"en","version":315},{"locale":"zh","version":78}],"i18nConfig":{"apiKey":"5960afab14104e319ab1a7db5057e908","projectId":43,"namespaceId":"qjpecyxapi","namespaceName":"b_fe_vss"}}],
    'ar': {
        b_fe_vss: ar_b_fe_vss
    },
    'en': {
        b_fe_vss: en_b_fe_vss
    },
    'zh': {
        b_fe_vss: zh_b_fe_vss
    }
};

export default resources;